export default "<button class=\"player__panel-button\" title=\"Open video file\">\n  <span class=\"icon-container\"></span>\n</button>\n"